import { Decimal } from 'decimal.js';
import { SalesOrderStatus } from '../constants/sales-order-status.js';
import { AR_NON_PREPAYMENT_STATUSES } from './ar-non-prepayment-statuses.js';
import { AR_VOIDED_STATUSES } from './ar-voided-statuses.js';
import { overpaymentExcess } from './overpayment-excess.js';
import { splitOpenAmount } from './split-open-amount.js';
const ZERO = new Decimal(0);
function unappliedOnly(unapplied) {
    return { due: ZERO, credit: ZERO, unapplied };
}
/**
 * One order's contribution to AR at one point in its history, by the same as-of rule the loader
 * applies in SQL (load-ar-open-items.ts). The ledger walks an order's events through this to turn
 * each into a balance change, so the two implementations must stay in step: the cross-surface
 * parity test in resolve-customer-ar-ledger.test.ts fails when they drift.
 */
export function arOrderBalance(order, { delivered, completed, applied, cash }) {
    const cashIsPrepayable = !order.isCreditReturn && cash.greaterThan(0);
    if (AR_VOIDED_STATUSES.includes(order.statusId)) {
        return unappliedOnly(cashIsPrepayable ? cash : ZERO);
    }
    const isOpen = delivered &&
        (order.statusId === SalesOrderStatus.DELIVERED ||
            (order.statusId === SalesOrderStatus.COMPLETE && order.hasCompletionDate && !completed));
    if (isOpen) {
        const { openAmount, unappliedAmount } = splitOpenAmount({
            originalAmount: order.totalPrice,
            appliedAmount: applied,
            isCreditReturn: order.isCreditReturn,
        });
        return {
            due: Decimal.max(openAmount, 0),
            credit: Decimal.max(openAmount.negated(), 0),
            unapplied: overpaymentExcess({ unappliedAmount, cash, totalPrice: order.totalPrice }),
        };
    }
    const isPrepayment = cashIsPrepayable &&
        ((order.hasDeliveryDate && !delivered) ||
            (!order.hasDeliveryDate && !AR_NON_PREPAYMENT_STATUSES.includes(order.statusId)));
    return unappliedOnly(isPrepayment ? cash : ZERO);
}
//# sourceMappingURL=ar-order-balance.js.map